module.exports = __webpack_public_path__ + "files/f36a6c0f3ada27bfcb6c07e3016802b2.png";